import { useEffect, useState } from "react";

function Counter({ target, suffix = "", duration = 2000 }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const increment = target / (duration / 16);

    const updateCount = () => {
      start += increment;

      if (start < target) {
        setCount(start);
        requestAnimationFrame(updateCount);
      } else {
        setCount(target);
      }
    };

    updateCount();
  }, [target, duration]);

  // decimal handle
  const display =
    target % 1 !== 0 ? count.toFixed(1) : Math.floor(count);

  return (
    <h2>
      {display}
      {suffix}
    </h2>
  );
}

export default Counter;